import type { ActorDataExport } from "@-/dev.improve.haniverse.lib.actor-data-transfer";
export function validateBackupRelationships(data: ActorDataExport): void {
  const ids = new Map<string, Set<string>>();
  for (const [key, rows] of Object.entries(data.tables)) {
    const set = new Set(rows.map((row) => row.id));
    if (set.size !== rows.length) {
      throw new Error(`Duplicate IDs in ${key}`);
    }
    ids.set(key, set);
  }
  const references = [
    ["collection", "userId", "user"],
    ["collectionMorpheme", "collectionId", "collection"],
    ["userCard", "fsrsCardId", "fsrsCard"],
    ["userCardReview", "cardId", "userCard"],
    ["userCardReview", "fsrsCardReviewLogId", "fsrsCardReviewLog"],
    ["userGraphemeMeaningCard", "userCardId", "userCard"],
    ["userGraphemePronunciationCard", "userCardId", "userCard"],
    ["userWordSentenceCard", "userCardId", "userCard"],
    ["userQuizCard", "userCardId", "userCard"],
  ] as const;
  for (const [child, field, parent] of references) {
    for (const row of data.tables[child]) {
      const value: unknown = Reflect.get(row, field);
      if (value !== null && (typeof value !== "string" || !ids.get(parent)?.has(value))) {
        throw new Error(`Broken ${child}.${field} reference`);
      }
    }
  }
}
